import { render, staticRenderFns } from "./DialogADD.vue?vue&type=template&id=2079ff60&scoped=true&"
import script from "./DialogADD.vue?vue&type=script&lang=js&"
export * from "./DialogADD.vue?vue&type=script&lang=js&"
import style0 from "./DialogADD.vue?vue&type=style&index=0&id=2079ff60&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2079ff60",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wp/Desktop/chuanti-pc/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2079ff60')) {
      api.createRecord('2079ff60', component.options)
    } else {
      api.reload('2079ff60', component.options)
    }
    module.hot.accept("./DialogADD.vue?vue&type=template&id=2079ff60&scoped=true&", function () {
      api.rerender('2079ff60', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/competition/components/DialogADD.vue"
export default component.exports